import { createAction, props } from '@ngrx/store';
import { JobDetails } from 'src/app/recruiting/jobs/details/models/job-details.model';

export enum JobsDetailsActionEnum {
    LoadJobDetails = '[JOB DETAILS] Load Job Details',
    LoadWeeklyRates = '[JOB DETAILS] Load Job Details Weekly Rates',
    LoadPerDiemRates = '[JOB DETAILS] Load Job Details Per Diem Rates',
    LoadJobDetailsFailed = '[JOB DETAILS] Load Job Details Failed',
    LoadJobDetailsSuccess = '[JOB DETAILS] Load Job Details Success'
}

export const loadJobDetails = createAction(JobsDetailsActionEnum.LoadJobDetails, props<{ jobId: number }>());

export const loadWeeklyRates = createAction(JobsDetailsActionEnum.LoadWeeklyRates, props<{ job: JobDetails }>());

export const loadPerDiemRates = createAction(JobsDetailsActionEnum.LoadPerDiemRates, props<{ job: JobDetails }>());

export const loadJobDetailsSuccess = createAction(
    JobsDetailsActionEnum.LoadJobDetailsSuccess,
    props<{ job: JobDetails }>()
);

export const loadJobDetailsFailed = createAction(
    JobsDetailsActionEnum.LoadJobDetailsFailed,
    props<{ error: string }>()
);
